import { useMutation } from 'react-query';
import { disableSMS, enableSMS } from 'services/PNOS/CampaignRegistryService';
import { HuntGroupService } from 'services';
import { filterLicensesByFeature } from 'utils/license-helpers';
import { TEAM_SMS } from 'constants/features';
import { useGetLicenseList } from 'hooks';

export const useTeamEnableSMS = (setSnackbar, formattedNum, corpAcctNbr) => {
  return useMutation(({ phoneNumber }) => enableSMS(phoneNumber, corpAcctNbr), {
    onError: (data) => {
      let message = '';

      if (data?.response?.data?.status === 'PORTING_INCOMPLETE') {
        message = data.response.data.message
          ? data.response.data.message
          : `SMS Enablement failed for ${formattedNum} - the number has not yet been ported over. Please contact Nextiva support for additional details.`;
      } else {
        message =
          'To enable Text Messaging, please click save to set primary number and then toggle Text Messaging on.';
      }
      setSnackbar({
        severity: 'error',
        message,
      });
    },
  });
};

export const useTeamDisableSMS = (setSnackbar, formattedNum, corpAcctNbr) => {
  return useMutation(
    ({ phoneNumber }) => disableSMS(phoneNumber, corpAcctNbr),
    {
      onError: () => {
        setSnackbar({
          severity: 'error',
          message: `Disabling SMS Enablement failed for ${formattedNum}. Please contact your administrator.`,
        });
      },
    },
  );
};

export const useTeamUpdateSMS = () => {
  return useMutation(({ huntGroupId, payload, locationId }) =>
    HuntGroupService.updateHuntGroupPhoneNumber(
      huntGroupId,
      payload,
      locationId,
    ),
  );
};

export const useTeamSMSLicense = () => {
  const { data: licenses } = useGetLicenseList();
  const teamSMSLicenses = filterLicensesByFeature(licenses, TEAM_SMS);
  const noTeamSMSLicenses = teamSMSLicenses.length === 0;
  const availableTeamSMSLicenses = teamSMSLicenses.filter(
    (license) => !!license.numberOfLicensesAvailable,
  );
  const noAvailableLicenses = teamSMSLicenses.every(
    (lic) => lic.numberOfLicensesAvailable === 0,
  );

  return {
    noAvailableLicenses,
    noTeamSMSLicenses,
    availableTeamSMSLicenses,
    teamSMSLicenses,
  };
};
